import { render, staticRenderFns } from "./HorizontalDivider.vue?vue&type=template&id=442652dc&scoped=true&"
import script from "./HorizontalDivider.vue?vue&type=script&lang=js&"
export * from "./HorizontalDivider.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalDivider.vue?vue&type=style&index=0&id=442652dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442652dc",
  null
  
)

export default component.exports